import React from 'react';
import ReactDOM from 'react-dom/client';
import BirthdayWebsite from './birthday';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BirthdayWebsite />
  </React.StrictMode>
);